/**
 * Shared color interpolation utility for heatmap visualizations.
 * Used by CourtHeatmap (SVG shot chart) and SlamMobileAnalyzer (canvas tracking heatmap).
 *
 * @param {Array<{pos: number, r: number, g: number, b: number}>} stops - Color stop array
 * @param {number} t - Normalized value 0-1
 * @returns {{r: number, g: number, b: number}} Interpolated RGB
 */
export function interpolateColorStops(stops, t) {
  const clamped = Math.max(0, Math.min(1, t));
  let lower = stops[0], upper = stops[stops.length - 1];
  for (let i = 0; i < stops.length - 1; i++) {
    if (clamped >= stops[i].pos && clamped <= stops[i + 1].pos) {
      lower = stops[i];
      upper = stops[i + 1];
      break;
    }
  }
  const range = upper.pos - lower.pos || 1;
  const f = (clamped - lower.pos) / range;
  return {
    r: Math.round(lower.r + (upper.r - lower.r) * f),
    g: Math.round(lower.g + (upper.g - lower.g) * f),
    b: Math.round(lower.b + (upper.b - lower.b) * f),
  };
}
